<template>
  <div id="">
    <router-view @new_language="updateLang" />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    lang() {
      return this.$i18n.locale;
    },
  },
  methods: {
    updateLang(lang) {
      this.$i18n.locale = lang;
    },
  },
};
</script>

<style src="./assets/css/style.css"></style>
<style>
.customTooltip .introjs-tooltip-title {
  color: #0a41c9;
}
.customTooltip .introjs-button.introjs-nextbutton {
  background: #213e7a;
  border-radius: 15px;
  color: white;
  padding: 0.5rem 1.5rem;
  text-shadow: none;
  border: none;
  font-weight: 500;
}
.customTooltip .introjs-button.introjs-nextbutton:focus {
  box-shadow: none;
}
.customTooltip .introjs-button.introjs-prevbutton {
  background: rgba(183, 195, 205, 1);
  border-radius: 15px;
  color: #5e6a79;
  padding: 0.5rem 1.5rem;
  text-shadow: none;
  border: none;
  font-weight: 500;
}
.customTooltip .introjs-button.introjs-prevbutton.introjs-disabled {
  background: #2422221f !important;
  border-radius: 15px;
  color: #9e9e9e !important;
  padding: 0.5rem 1.5rem;
  text-shadow: none;
  border: none;
  font-weight: 500;
  display: none;
}
.customTooltip .introjs-tooltip-header {
  display: none;
}
</style>
